<script>
export default {
  name: 'PublicLayout',
}
</script>

<template>
  <main class="bg-gray-700">
    <slot />
  </main>
</template>
